import { createContext, useContext } from 'react';
import { type paletteTokens } from './generated/paletteVariables';
import { type ITheme } from './index';

/** Two-level partial for palette overrides */
type TwoLevelPartial<T> = {
  [P in keyof T]?: T[P] extends object ? { [K in keyof T[P]]?: T[P][K] } : T[P];
};

/** Deep partial for theme overrides */
type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export type BrandingContextValue = {
  overrideTheme?: DeepPartial<ITheme>;
  overridePalette?: TwoLevelPartial<typeof paletteTokens>;
};

export const BrandingContext = createContext<BrandingContextValue | undefined>(
  undefined,
);

/**
 * Hook to access branding overrides from a parent BrandingProvider.
 * Returns undefined if not wrapped in a BrandingProvider.
 */
export const useBrandingOverrides = (): BrandingContextValue | undefined => {
  return useContext(BrandingContext);
};
